import ITheme from '@/interfaces/iTheme';

export class SimpleTheme implements ITheme
{
    static Id = 'simple';
    id = SimpleTheme.Id;

    name = 'Simple';

    colors = {
                application: '#FFFFFF',
                text: '#000000',
                confirm: '#1976D2',
                confirmText: 'white',
                accent: '#1976D2',

                // Challenge card colors
                solved: '#EEEEEE',
                solvedText: '#000000DE',
                lockedText: '#000000DE',
                unsolved: '#B3E5FC',
                unsolvedText: '#000000DE',
                noMoreAttempts: '#FBA6A6',
                noMoreAttemptsText: '#000000DE',
                disabled: '#B3E5FC',
                disabledText: '#000000DE',
                disabledIcon: '#C62828',

                windowBorder: '#0000001F',

                activeTab: '#1976D2',
                dialogText: '#303030',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#1976D2',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: '#666666',
                tableHeaderSelectAllButtons: '#1976D2',

                //settings and bulk select checkboxes 
                checkedFill:'#1976D2',
                checkedBorder:'#1976D2',

                // focus indicators
                focusVisibleIndicator:  'black',

                // the most common color from the background image with sufficient contrast
                backgroundImageColor: '',

                actionButtonBackground: 'white',
                actionButtonText: 'black',                
             };

    fontFamily = "Roboto";
    landingFontFamily = "space_frigate";
    isDark = false;
    backgroundImage = undefined;
}
